import {QuestionCircleOutlined} from '@ant-design/icons';
import {Button, Tooltip} from 'antd';
import classNames from 'classnames';
import {useNavigate} from 'react-router-dom';
import Style from './index.module.scss';
import type {HTMLAttributes} from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
    extra?: React.ReactNode;
    canBack?: boolean;
    hiddenIcon?: boolean;
    help?: string;
    tips?: string;
    backUrl?: string;
}
const Index = ({
    children,
    extra,
    canBack,
    help,
    tips,
    hiddenIcon = false,
    className,
    backUrl,
    ...props
}: Props) => {
    const navigate = useNavigate();

    function onBack() {
        if (window.opener) {
            window.close();
        }
        backUrl ? navigate(backUrl) : navigate(-1);
    }

    return (
        <div {...props}>
            <div className={classNames(Style.root, className)}>
                <div
                    className={classNames(Style.title, {
                        [Style.noIcon]: hiddenIcon,
                    })}>
                    {children}
                    {help && (
                        <Tooltip title={help}>
                            <QuestionCircleOutlined className={Style.ques} />
                        </Tooltip>
                    )}
                    {canBack && (
                        <Button
                            onClick={() => onBack()}
                            size="small"
                            style={{fontSize: 12}}>
                            返回
                        </Button>
                    )}
                </div>
                {extra}
            </div>
            {tips && <p className={Style.tips}>{tips}</p>}
        </div>
    );
};
export default Index;
